__turbopack_context__.v({
  "className": "manuka_f14e08e9-module__t1giHG__className",
  "variable": "manuka_f14e08e9-module__t1giHG__variable",
});
